import React from "react";
import { NavLink } from "react-router-dom";
import { ListGroup, ListGroupItem } from 'reactstrap';

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import MyDateRenderer from "./MyDateRenderer";
import ConfirmModal from "./ConfirmModal";
import CustomerCategoryLabel from "./CustomerCategoryLabel";

import { useDispatch, useSelector } from "react-redux";
import * as ineDashboardActions from "../actions/IneDashboardActions";

const IneDashboardList = (props) => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.login.user);

    const [selectedId, setSelectedId] = React.useState(0);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [selectedUserId, setSelectedUserId] = React.useState(-1);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    const [showAssignModal, setShowAssignModal] = React.useState(false);

    const getInvoiceNumberDisplay = (item) => {
        var value = "";

        if(item.crmInvoiceNumber && item.crmInvoiceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.crmInvoiceNumber;
        }

        if(item.taxInvoiceNumber && item.taxInvoiceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.taxInvoiceNumber;
        }

        return value;
    }

    const onCloseModalClick = () => {
        setSelectedId(0);
        setSelectedIndex(-1);
        setSelectedUserId(-1);
        setShowAssignMeModal(false);
        setShowAssignModal(false);
    }

    const assignMeTicket = (id, index) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(user.id);
        setShowAssignMeModal(true);
    }

    const onAssignMeTicket = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(ineDashboardActions.assignIneRequest(selectedId, selectedUserId, true, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    const assignTicket = (id, index, userId) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(userId);
        setShowAssignModal(true);
    }

    const onAssignTicket = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(ineDashboardActions.assignIneRequest(selectedId, selectedUserId, false, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    return (
        <div className="tasks-list">
            <div className="d-flex mb-2">
                <div className="flex-grow-1">
                    <h6 className="fs-14 text-uppercase fw-semibold mb-0">{props.title} <small className={`badge ${props.titleClass} align-bottom ms-1 totaltask-badge`}>{props.list ? props.list.length : 0}</small></h6>
                </div>
            </div>
            <SimpleBar className="tasks-wrapper px-3 mx-n3" forceVisible={true} autoHide={false}>
                <div className="tasks">
                    {props.list && props.list.map(function(item, index){
                        return(
                            <div className={`card tasks-box ${item.ticketType === "CONTAINER" ? ["card-light", "border", "border-1", props.borderClass].join(" ") : ""}`} key={index}>
                                <div className="card-body">
                                    <div className="d-flex">
                                        <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title">
                                            <NavLink to={`/ine-request-edit/${item.id}`} className="text-body d-block">{item.requestNumber}</NavLink>
                                        </h6>
                                    </div>
                                    {item.customerName &&
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-dark" style={{marginBottom:0}}>
                                        {item.customerName}
                                        <CustomerCategoryLabel value={item.customerCategory || ""} />
                                    </p>
                                    }
                                    <p className="fs-11 flex-grow-1 text-truncate text-muted">
                                        {getInvoiceNumberDisplay(item)}
                                    </p>
                                    <div className="align-items-center">
                                        <div className="pt-1" style={{textAlign:"right"}}>
                                            <div>
                                                {(props.title === "New" || props.title === "Approval Of Contract" || props.title === "Issue Work Order Form") && user && user.isIneAreaManager && !user.isIneManager && !item.areaManagerUserId &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                                {(props.title === "Awaiting Signature") && user && user.isIneTechnicalManager && !user.isIneManager && !item.technicalManagerUserId &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                                {(props.title === "Perform Inspection 1") && user && user.isIneInspector && !user.isIneManager && !item.inspectorUserId &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                                {(props.title === "Completed") && user && user.isIneFinance && !user.isIneManager && !item.financeUserId &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }

                                                {(props.title === "New" || props.title === "Approval Of Contract" || props.title === "Issue Work Order Form") && user && user.isIneManager && !item.areaManagerUserId &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {props.areaManagerUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                                {(props.title === "Awaiting Signature") && user && user.isIneManager && !item.technicalManagerUserId &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {props.technicalManagerUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                                {(props.title === "Perform Inspection 1") && user && user.isIneManager && !item.inspectorUserId &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {props.inspectorUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                                {(props.title === "Completed (Pending Invoice) 1") && user && user.isIneManager && !item.financeUserId &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {props.financeUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.areaManagerUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.technicalManagerUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.inspectorUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.financeUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.storeKeeperUserName}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {item.ticketType === "CONTAINER" && 
                                    <div className="mt-3">
                                        <ListGroup>
                                            {item.draftCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Draft <span className="badge bg-success">{item.draftCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.newCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                New <span className="badge bg-success">{item.newCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.salesActionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Sales Action <span className="badge bg-success">{item.salesActionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.approvalOfContractCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Approval Of Contract <span className="badge bg-success">{item.approvalOfContractCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.issueWorkOrderFormCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Issue Work Order Form <span className="badge bg-success">{item.issueWorkOrderFormCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.performInspectionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Perform Inspection <span className="badge bg-success">{item.performInspectionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.awaitingSignatureCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Awaiting Signature <span className="badge bg-success">{item.awaitingSignatureCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.completedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Completed <span className="badge bg-success">{item.completedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.closedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Closed <span className="badge bg-success">{item.closedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.abortedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Aborted <span className="badge bg-success">{item.abortedCount}</span>
                                            </ListGroupItem>
                                            }
                                        </ListGroup>
                                    </div>
                                    }
                                </div>
                                <div className="card-footer border-top-dashed" style={{paddingTop:5, paddingBottom:5}}>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <ul className="link-inline mb-0" style={{paddingLeft:0}}>
                                                <li className="list-inline-item">
                                                    <i className="ri-user-add-line align-bottom"></i> {item.addedBy} | <MyDateRenderer value={item.dateAdded} format="mm/dd/yy" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <ul className="link-inline mb-0">
                                                <li className="list-inline-item">
                                                    <i className="ri-question-answer-line align-bottom"></i> {item.commentCount}
                                                </li>
                                                <li className="list-inline-item">
                                                    <i className="ri-attachment-2 align-bottom"></i> {item.documentCount}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress progress-sm bg-soft-success">
                                    <div className={`progress-bar ${props.titleClass}`} style={{width: "100%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        );
                    })}

                    {props.list && props.list.length === 0 &&
                    <div className="">
                        <div className="">
                            <div className="d-flex mb-2">
                                <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title"><div className="text-body d-block">No {props.title} Tickets</div></h6>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </SimpleBar>

            <ConfirmModal message={"Are you sure you want to Assign the INE Ticket?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeTicket} />
            <ConfirmModal message={"Are you sure you want to Assign the INE Ticket?"} show={showAssignModal} onCloseClick={onCloseModalClick} onYesClick={onAssignTicket} />
        </div>
    );
};

export default IneDashboardList;
